export default __webpack_public_path__ + "static/assets/blank.2ecf731f.gif";